import { Link, LinkProps } from "react-router-dom"

import styled from "styled-components"
import { devices } from "../../themes/theme"

interface IButtonLinkProps extends LinkProps {
  $disabled?: boolean
  $fullwidth?: boolean
  $outline?: boolean
  $shadow?: boolean
  $size?: "lg"
}

// see: https://github.com/styled-components/styled-components/issues/1198#issuecomment-336628848
const StyledLink = styled(Link)<IButtonLinkProps>`
  background-color: ${(props) =>
    props.$outline
      ? props.theme.colors.boxBackground
      : props.theme.colors.primary};
  ${(props) =>
    props.$disabled && `opacity: 0.5; cursor: default; pointer-events: none;`}
  border: ${(props) =>
    props.$outline ? `1px solid ${props.theme.colors.primary}` : `none`};
  box-sizing: border-box;
  color: ${(props) =>
    props.$outline
      ? props.theme.colors.primary
      : props.theme.colors.buttonText};
  display: block;
  width: ${(props) => (props.$fullwidth ? `100%` : `unset`)};

  ${(props) =>
    props.$size === "lg"
      ? `
        padding-block: .8em;
        width: 100%;
        @media(${devices.tablet}) { 
          padding: 1em 6em;
          width: unset;
        }`
      : `padding: 1.2em 3.5rem;`}
  ${(props) =>
    props.$shadow && "box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.12);"}
  
  // text
  font-size: ${(props) =>
    props.$size === "lg"
      ? `clamp(1rem, 0.9rem + 0.5vw, 1.5rem)`
      : ` clamp(.8rem, 0.735rem + 0.325vw, 1.125rem)`};
  font-weight: 700;
  letter-spacing: 0.04em;
  text-align: center;
  text-decoration: none;
`

const ButtonLink = (props: IButtonLinkProps) => {
  const { children, ...rest } = props
  return <StyledLink {...rest}>{children}</StyledLink>
}

export { ButtonLink }
